module.exports = __webpack_public_path__ + "img/status_2.3ab64e53.png";